export default "__VITE_ASSET__Cqz6SkmO__"